<template>
<fragment :class="[Object.entries(itemsCart.list).length <= 0 ? 'col-md-12' : null]">
    <LoadingApp
        :isLoading.sync="isLoading" 
        :is_full_page="true"
    /> 
    <template v-if="Object.entries(itemsCart.list).length > 0">
        <div class="col-lg-8">
            <ProgressiveDiscountNotice :notice="progressiveDiscountNotice" />
            <FreeShippingNotice
                :minAmount="freeShippingNoticeAmount"
                :netAmount="productsNetAmount"
            />
            <CartTableProducts
                :products_settings="products_settings"
            >
                <template #footer="slotProps">
                    <tr>
                        <td :colspan="slotProps.colspan" style=" justify-content: space-between; align-items: center; flex-direction: row;" class="clearfix">
                            <div style="float: left;">
                                <c-ancora
                                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                    padding=".85rem 2rem"
                                    fontFamily="Open Sans, sans-serif"
                                    textTransform="initial"
                                    :color="btn_limpar_carrinho.color"
                                    backgroundColor="transparent"
                                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                    :borderColor="btn_limpar_carrinho.border_color"
                                    fontSize="1.4rem"
                                    height="unset"
                                    href="#" 
                                    @click.prevent.stop="destroyCart()" 
                                >
                                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                                        {{ isBudgetLayout ? 'Limpar Orçamento' : 'Limpar Carrinho' }}
                                    </span>
                                </c-ancora>
                            </div>
                            <div class="float-right">
                                <c-ancora
                                    padding=".85rem 2rem"
                                    fontFamily="Open Sans, sans-serif"
                                    textTransform="initial"
                                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                                    :color="$root.$children[0].theme.products.button.color"
                                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                                    :borderColor="$root.$children[0].theme.products.button.border_color"
                                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                                    height="unset"
                                    :href="itemsCart.last_url_category || $baseUrl"
                                >
                                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                                        {{ isBudgetLayout ? 'Orçar' : 'Comprar' }} mais
                                    </span>
                                </c-ancora>
                            </div>
                        </td>
                    </tr>
                </template>
            </CartTableProducts>
        </div>
        <div class="col-lg-4">
            <CartSummary :cepdestination="cepdestination"/>
            <aside class="sidebar-product padding-left-lg mobile-sidebar">
            </aside>
        </div>
        <div class="col-12">
            <ProgressiveDiscountNotice :notice="progressiveDiscountNotice" :showMessage="false" :showRanges="true" />
        </div>
    </template>
    <div 
        v-if="Object.entries(itemsCart.list).length <= 0" 
        class="col-md-12" 
        style="height:calc(50vh);display:flex; align-items:center;justify-content:center"
    >
        <span>
            <h2 style="color:#DB1;">Seu carrinho de {{ isBudgetLayout ? 'orçamentos' : 'compras' }} esta vazio :(</h2>
        </span>
    </div>
</fragment>
</template>

<script>
import CartSummary from '../../components/cart/CartSummary'
import LoadingApp from '../../components/LoadingApp'
import VueLoadImage from 'vue-load-image'
import { Fragment } from 'vue-fragment'
import Currency from '../../helpers/parseCurrency'
import {mapState, mapActions} from 'vuex'
import {CAncora} from '../../components/Styles/Button/styled'
import { CInputQtd, CCartTableContainer } from '../../components/Styles/Template/styled'
import CartTableProducts from '../../components/CartTableProducts.vue'
import ProgressiveDiscountNotice from '../../components/cart/ProgressiveDiscountNotice.vue'
import FreeShippingNotice from '../../components/cart/FreeShippingNotice.vue'
import { buildCartTrackingItems } from '../../helpers/tracking'

export default {
    name: 'CartPage',
    props: {
        items_cart:{default:[]},
        cepdestination:{default:null},
        products_settings:{required:true}
    },
    components: {
        CartSummary,
        LoadingApp,
        Fragment,
        CartTableProducts,
        'vue-load-image': VueLoadImage,
        'c-ancora': CAncora,
        'c-input-qtd': CInputQtd,
        'cart-table-container': CCartTableContainer,
        ProgressiveDiscountNotice,
        FreeShippingNotice
    },
    data() {
        return {
            isLoading: false,
            currency: Currency,
            data: null,
            textTransform: this.$root.$children[0].theme?.products?.product_page?.text_transform_title ?? '',
            btn_limpar_carrinho: {
                border_color: this.$root.$children[0].theme?.products?.button?.btn_limpar_carrinho?.border_color ?? '#ccc',
                color: this.$root.$children[0].theme?.products?.button?.btn_limpar_carrinho?.color ?? '#777'
            }
        }
    },
    created() {
        this.ActionSetItemsCart(this.items_cart)
        this.trackViewCart()
    },
    // mounted() {
    //     var self = this
    //     $(function () {
    //         jQuery('.qtd_product').TouchSpin({
    //             verticalbuttons: true,
    //             verticalup: '',
    //             verticaldown: '',
    //             verticalupclass: 'icon-up-dir',
    //             verticaldownclass: 'icon-down-dir',
    //             buttondown_class: 'btn btn-outline',
    //             buttonup_class: 'btn btn-outline',
    //             initval: 1,
    //             min: 1
    //         })
    //         jQuery('.qtd_product').on('touchspin.on.startdownspin', function (e) {
    //             let { value, dataset } = e.target
    //             self.data = {
    //                 pro_id: dataset.proid,
    //                 key: dataset.key,
    //                 qtd: value,
    //                 action: 'decrement',
    //                 color_id: dataset.colorid,
    //                 size_id: dataset.sizeid
    //             }
    //             self.updateCart()
    //         })
    //         jQuery('.qtd_product').on('touchspin.on.startupspin', function (e) {
    //             let { value, dataset } = e.target
    //             self.data = {
    //                 pro_id: dataset.proid,
    //                 key: dataset.key,
    //                 qtd: value,
    //                 action: 'increment',
    //                 color_id: dataset.colorid,
    //                 size_id: dataset.sizeid
    //             }
    //             self.updateCart()
    //         })
    //     })
    // },
    methods: {
        ...mapActions("cart", [
            "ActionRemoveItemCart",
            "ActionUpdateItemCart",
            "ActionSetItemsCart",
            "ActionDestroyCart",
            "ActionRemoveProductGroup"
        ]),
        ...mapActions("toast", [
            "setShowToast",
            "setMessageToast",
            "setTimerToast",
            "setIconToast",
            "setThemeToast"
        ]),
        trackViewCart() {
            if (typeof gtag !== 'function' || !this.items_cart?.list?.length) {
                return
            }

            gtag('event', 'view_cart', {
                pageTitle: this.$root.$children[0].$attrs.company?.nome_fantasia ?? '',
                pageCategory: 'Carrinho',
                ecommerce: {
                    currency: 'BRL',
                    value: Number(this.items_cart.totalAmount ?? this.items_cart.subTotal ?? 0),
                    items: buildCartTrackingItems(this.items_cart.list)
                }
            })
        },
        // setQuantityMinus(item) {
        //     let qtd = Number(item.qtd_cart)
        //     let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)
        //     if(qtd < 2 || qtd <= min) {
        //         this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
        //         qtd = min
        //         return
        //     }
        //     let resto = Number(qtd) % Number(item.quantity_conversion_factor)
        //     let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto
        //     let qtdAdd = Number(qtd) - qtdSobra
        //     qtd = qtdAdd < Number(min) ? Number(min) : qtdAdd

        //     this.data = {
        //         pro_id: item.id,
        //         key: item.key_cart,
        //         qtd: qtd,
        //         action: 'decrement',
        //         color_id: item.color_id_cart,
        //         size_id: item.size_id
        //     }
        //     this.updateCart()
        // },
        // setQuantityPlus(item) {
        //     let qtd = Number(item.qtd_cart)
        //     let max = item?.maximum_sale_quantity
        //     if(max && qtd >= max) {
        //         this.alertToast(`Quantidade máxima atingida para este produto.`)
        //         return
        //     }
        //     let resto = Number(qtd) % Number(item.quantity_conversion_factor)
        //     let qtdFalta = Number(item.quantity_conversion_factor) - resto
        //     if(max && (qtdFalta + Number(qtd)) > Number(max)) {
        //         this.alertToast(`Quantidade máxima atingida para este produto.`)
        //         qtd = Number(max)
        //         return
        //     }
        //     qtd = qtdFalta + Number(qtd)

        //     this.data = {
        //         pro_id: item.id,
        //         key: item.key_cart,
        //         qtd: qtd,
        //         action: 'increment',
        //         color_id: item.color_id_cart,
        //         size_id: item.size_id
        //     }
        //     this.updateCart()
        // },
        // onBlurMinimumQuantity(item, qtd) {
        //     // console.log(qtd)
        //     let quantity = qtd
        //     let min = Number(item?.quantity_conversion_factor > item.minimum_sale_quantity ? item.quantity_conversion_factor : item.minimum_sale_quantity)
        //     let max = item?.maximum_sale_quantity

        //     if(Number(quantity) < Number(min)) {
        //         this.alertToast(`Este produto possui quantidade mínima de ${min} ${item.pro_sigla_medida}`)
        //         item.qtd_cart = Number(min)
        //         quantity = Number(min)
        //         this.data = {
        //             pro_id: item.id,
        //             key: item.key_cart,
        //             qtd: quantity,
        //             action: 'setQtd',
        //             color_id: item.color_id_cart,
        //             size_id: item.size_id
        //         }
        //         this.updateCart()
        //         return
        //     }
        //     let resto = Number(quantity) % Number(item.quantity_conversion_factor)
        //     let qtdFalta = Number(item.quantity_conversion_factor) - resto
        //     let qtdSobra = resto == 0 ? Number(item.quantity_conversion_factor) - resto : resto

        //     if(max && Number(quantity) >= Number(max) && !item.color_id && !item.size_id) {
        //         // this.alertToast(`Este produto possui quantidade máxima de ${max}.`)
        //         if(Number(quantity) > max) {
        //             this.alertToast(`Este produto possui quantidade máxima de ${max} ${item.pro_sigla_medida}`)
        //             item.qtd_cart -= Number(qtdSobra)
        //             quantity -= Number(qtdSobra)
        //             return
        //         }
        //         if(qtdSobra != Number(item.quantity_conversion_factor)) {
        //             this.alertToast(`Quantidade máxima atingida.`)
        //             item.qtd_cart -= Number(qtdSobra)
        //             quantity -= Number(qtdSobra)
        //             return
        //         }
        //         // item.qtd_cart = Number(max)
        //         // quantity = Number(max)
        //         this.data = {
        //             pro_id: item.id,
        //             key: item.key_cart,
        //             qtd: quantity,
        //             action: 'setQtd',
        //             color_id: item.color_id_cart,
        //             size_id: item.size_id
        //         }
        //         this.updateCart()
        //         return
        //     }
            
        //     if(resto != 0) {
        //         if(qtdFalta <= qtdSobra) {
        //             quantity = qtdFalta + Number(quantity)
        //         } else {
        //             quantity = Number(quantity) - qtdSobra
        //         }
        //     }

        //     // if(Number(quantity) < Number(min)) {
        //     //     this.alertToast(`Este produto possui quantidade mínima de ${min}.`)
        //     //     quantity = Number(min)
        //     //     return
        //     // }

        //     // console.log(quantity)
        //     // console.log(item)

        //     // let info = event.target
        //     // if(isNaN(parseInt(info.value))) {
        //     //     info.value = qtd_atual
        //     // }
        //     // if(!info.value || info.value == '') {
        //     //     info.value = 1
        //     // }
        //     // if(info.value < 1) {
        //     //     info.value = 1
        //     // }
        //     this.data = {
        //         pro_id: item.id,
        //         key: item.key_cart,
        //         qtd: quantity,
        //         action: 'setQtd',
        //         color_id: item.color_id_cart,
        //         size_id: item.size_id
        //     }
        //     this.updateCart()
        // },
        alertToast(msg = null, icon = "exclamation", theme = 'warning', timer = 4) {
            this.setThemeToast(theme)
            this.setMessageToast(msg)
            this.setIconToast(icon)
            this.setTimerToast(timer)
            this.setShowToast(true)
            setTimeout(() => {
                this.setShowToast(false)
            }, (timer * 1000));
        },
        // async updateCart() {   
        //     this.isLoading = true
        //     await this.ActionUpdateItemCart(this.data)
        //     .then((response) => {
        //         this.isLoading = false
        //         let { data } = response
        //         this.ActionSetItemsCart(data)
        //     })
        //     .catch((error) => {
        //         this.isLoading = false
        //         // console.log(error)
        //         const { data } = error
        //         if(data?.list.length) {
        //             let qtdPrev = data.list.find(el => {
        //                 if((el.id == data.id && el.color_id_cart == data.color_id && el.size_id == data.size_id)) {
        //                     return el
        //                 }
        //             }).qtd_cart
        //             this.itemsCart.list.find(el => {
        //                 if((el.id == data.id && el.color_id_cart == data.color_id && el.size_id == data.size_id)) {
        //                     return el
        //                 }
        //             }).qtd_cart = qtdPrev
        //         }
                
        //         this.alertToast(error?.msg ?? error)
        //         // this.$swal({
        //         //     title: `<span style="color: ${this.$root.$children[0].theme?.text_site_color ?? '#4a505e'}; display: inline-block; padding-bottom: 20px; padding: 8px; font-size: 2rem; font-weight: 600;">
        //         //             ${error?.msg ?? error}
        //         //         </span>`,
        //         //     icon: 'warning',
        //         //     confirmButtonColor: '#3085d6',
        //         //     confirmButtonText: `<span style="font-size: 1.6rem; font-weight: 500">OK</span>`,
        //         //     background: this.$root.$children[0].theme?.background_color_site ?? '#fff',
        //         // })
        //     })
        // },
        // removeProductGroup(id, children) {
        //     let children_uuids = []
        //     for (const i in children) {
        //         if (Object.hasOwnProperty.call(children, i)) {
        //             const element = children[i];
        //             children_uuids.push(element.uuid)
        //         }
        //     }
        //     let body = {
        //         father_uuid: id,
        //         children_uuids
        //     }
        //     this.ActionRemoveProductGroup(body)
        //      .then((resp) => {
        //         let {data} = resp
        //         this.ActionSetItemsCart(data)
        //     })
        //     .catch((error) => {
        //         if(error.msg) {
        //             alert(error.msg)
        //             return
        //         }
        //         alert(error)
        //     })
        // },
        // async removeItem(pro_id, index) {   
        //     this.isLoading = true
        //     let data = {
        //         pro_id: pro_id,
        //         key: index
        //     }
        //     await this.ActionRemoveItemCart(data)
        //     .then((resp) => {
        //         this.isLoading = false
        //         let {data} = resp
        //         this.ActionSetItemsCart(data)
        //     })
        //     .catch((error) => {
        //         this.isLoading = false
        //         if(error.msg) {
        //             alert(error.msg)
        //             return
        //         }
        //         alert(error)
        //     })
        // },  
        async destroyCart() {   
            this.isLoading = true
            await this.ActionDestroyCart()
            .then((resp) => {
                this.isLoading = false
                let {data} = resp
                this.ActionSetItemsCart(data)
            })
            .catch((error) => {
                this.isLoading = false
                if(error.msg) {
                    alert(error.msg)
                    return
                }
                alert(error)
            })
        },
        // getQtdVModel(event, qtd_atual) {
        //     let info = event.target
        //     if(isNaN(parseInt(info.value))) {
        //         info.value = qtd_atual
        //     }
        //     if(!info.value || info.value == '') {
        //         info.value = 1
        //     }
        //     if(info.value < 1) {
        //         info.value = 1
        //     }
        //     this.data = {
        //         pro_id: info.dataset.proid,
        //         key: info.dataset.key,
        //         qtd: info.value,
        //         action: 'setQtd',
        //         color_id: info.dataset.colorid,
        //         size_id: info.dataset.sizeid
        //     }
        //     this.updateCart()
        // },
        // calculateSubTotal(item) {
        //     let price = !item.price_to ? item.pro_price_site : item.price_to
        //     return parseFloat(price) * item.qtd_cart
        // }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        progressiveDiscountNotice() {
            return this.itemsCart?.progressiveDiscountNotice ?? null
        },
        freeShippingNoticeAmount() {
            return this.$root.$children[0].$attrs.company?.settings?.free_shipping_notice_amount ?? 0
        },
        productsNetAmount() {
            return this.itemsCart?.productsNetAmount ?? this.itemsCart?.totalAmount ?? 0
        }
    },
    watch:{
        itemsCart(cart) {
            if(!cart) return
            cart.list.forEach(element => {
                element.pro_name_site = this.textTransform == 'uppercase' ? element.pro_name_site.toUpperCase() :
                    this.textTransform == 'lowercase' ? element.pro_name_site.toLowerCase() :
                    this.textTransform == 'initial' ? (element.pro_name_site[0].toUpperCase() + element.pro_name_site.substr(1).toLowerCase()) :
                    this.textTransform == 'capitalize' ? (element.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })): element.pro_name_site
            });
        }
    }
}
</script>

<style scoped>
.qtd_product[readonly] {
    background: #fff;
    opacity: 0.7;
}
</style>
